import React, { useEffect, useState } from 'react'
import '../../../Styles/App/HomeMB2.css'
import { Fade } from 'react-awesome-reveal'
import ServicioApartado from '../../../Images/HomeMB2/ServicioApartado.png'
import Button from '@mui/material/Button'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { CUESTIONARIO, CITAS_MB } from '../../../Constants/routesConstants'
import RegisterMb2 from '../../Login/RegisterMb2'

const Section5HomeWeb = (props) => {
  const userLogin = useSelector((state) => state.userLogin)
  const { loading, error, userInfo } = userLogin
  const navigate = useNavigate()

  const [openSingUp, setOpenSingUp] = useState(false)
  const handleOpenSingUp = () => {
    // gtmOpenRegisterUNL()
    setOpenSingUp(!openSingUp)
  }

  const handleCloseSingUp = () => {
    setOpenSingUp(false)
  }
  return (
    <section className="ContainerSection5MB">
      <img
        src={
          'https://barterluxe-mx.s3.us-east-2.amazonaws.com/FounditWeb/Desktop/FoundIT+Logos/Foundit+Logo+BLACK.png'
        }
      />
      {/* triggerOnce */}
      <div className="cardSecttion5MB">
        {/* <Fade cascade damping={0.5}  > */}
        <Fade className="reveal" delay={1000} triggerOnce>
          <div className="section5MB-1">
            <span>Valua tus piezas en línea</span>
            {/* <div className="bottomLink">
              <Button
                onClick={
                  userInfo
                    ? function () {
                        navigate(CUESTIONARIO)
                        // gtmGoTo_EmpeñaAqui_Log()
                      }
                    : function () {
                        handleOpenSingUp()
                      }
                }
                className="btnLink"
                size="small"
              >
                Valuar
                <img
                  src={
                    'https://barterluxe-mx.s3.us-east-2.amazonaws.com/FounditWeb/Desktop/Iconos/VectorArrowWhite.png '
                  }
                />
              </Button>
            </div> */}
          </div>
        </Fade>
        <Fade delay={500} triggerOnce>
          <div className="section5MB-2">
            <div className="contentImgs">
              <img
                className="imgmarco"
                src={
                  'https://barterluxe-mx.s3.us-east-2.amazonaws.com/FounditWeb/Desktop/Home/MarcoCafe.png'
                }
              />
              <img
                className="imgbolso"
                src={
                  'https://barterluxe-mx.s3.us-east-2.amazonaws.com/FounditWeb/Desktop/Home/DSC05812.png'
                }
              />
              <img
                className="imgpersona"
                src={
                  'https://barterluxe-mx.s3.us-east-2.amazonaws.com/FounditWeb/Desktop/Home/DSC02483.png'
                }
              />
            </div>
          </div>
        </Fade>
        <Fade className="reveal" delay={1500} triggerOnce>
          <div className="section5MB-3">
            <span>Visita nuestro showroom</span>
            <div className="bottomLink">
              <Button
                onClick={
                  function () {
                    window.open(
                      'https://api.whatsapp.com/send/?phone=5641819020&text=Hola',
                      '_blank'
                    )
                  }
                  // userInfo
                  //   ? function () {
                  //       navigate(CITAS_MB)
                  //       // gtmGoTo_EmpeñaAqui_Log()
                  //     }
                  //   : function () {
                  //       handleOpenSingUp()
                  //     }
                }
                className="btnLink"
                size="small"
              >
              Generar cita
                <img
                  src={
                    'https://barterluxe-mx.s3.us-east-2.amazonaws.com/FounditWeb/Desktop/Iconos/VectorArrowWhite.png '
                  }
                />
              </Button>
            </div>
          </div>
        </Fade>
        {/* </Fade> */}
      </div>
      <RegisterMb2
        open={openSingUp}
        onClose={handleCloseSingUp}
        props={props}
      />
    </section>
  )
}

export default Section5HomeWeb
